import { createFileRoute } from '@tanstack/react-router';

type DraftsSearchParams = {
  q?: string;
  page?: number;
};

export const Route = createFileRoute('/orders/drafts/')({
  validateSearch: (search: Record<string, unknown>): DraftsSearchParams => ({
    q: typeof search.q === 'string' ? search.q : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
  }),
});
